module.exports = __webpack_public_path__ + "staticcomp/img/share.3120c33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/7/share.jpg
// module id = cQir
// module chunks = 39